import * as ActionTypes from "./actionTypes";

export function getCultures() {
	return { type: ActionTypes.GET_CULTURES };
}

export function getCulturesSuccess(cultures) {
	return { type: ActionTypes.GET_CULTURES_SUCCESS, cultures };
}

export function getCulturesFailure(errorMessage) {
	return { type: ActionTypes.GET_CULTURES_FAILURE, errorMessage };
}
